var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#twitter_svg__clip0_19508_63693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.636 8.469L18.916 0H17.19l-6.32 7.353L5.822 0H0l7.633 11.12L0 20h1.725l6.674-7.765L13.73 20h5.822L11.636 8.469zm-2.362 2.748L8.5 10.11 2.346 1.3h2.65l4.966 7.11.774 1.107 6.455 9.242h-2.65l-5.267-7.541z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "twitter_svg__clip0_19508_63693"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgTwitter;